import { makeStyles, Paper, Typography } from "@material-ui/core";
import React from "react";

const Avisos = () => {
  const classes = useStyles();
  return (
    <div>
      <Paper className={classes.paper}>
        <Typography variant="h4" className={classes.title} gutterBottom>
          Aviso Legal
          </Typography>
        <Typography className={classes.bold} gutterBottom>
          <strong>Versión Junio 2020</strong>
        </Typography>
        <br />
        <br />
        <Typography>
          <strong>INFORMACIÓN GENERAL 1.1.</strong>
          <br />
          <br />
         ¿Quién está detrás de esta Página Web? Detrás
          de esta Página Web con dominio spathios.com, en adelante, “Spathios” o
          “la Página Web”, se encuentra la empresa <span style={{ color: "#005795" }}>
            <strong>hygge.SL</strong>
          </span>{" "}, cuyos
          datos, para cualquier cosa que necesite, se proporcionan a
          continuación:
          <br />
          <br />
          <span style={{ color: "#005795" }}>
            <strong>hygge.SL</strong>
          </span>{" "}
          <br />
          <strong>NIF: B-0000000</strong> <br />
          <strong>
            Domicilio: Av. xxxxxxx xxxxxxx, 16, CP: 15000 de Galicia
          </strong>{" "}
          <br />
          <strong>
            Correo electrónico de contacto: info@spathios.com
          </strong>{" "}
          <br />
          <strong>Teléfono de contacto: 633 000 000</strong> <br /> <br />
          <strong>Datos registrales: </strong>inscrita en el Registro Mercantil
          de Galicia, Tomo 47274, Folio: 83, Hoja 000000, Inscripción: 1<br />
          <br />
          <strong>1.2 Descripción de la Página Web y finalidad</strong>
          <br />
          <br />
          La presente Página Web pretende presentar a <span style={{ color: "#005795" }}>
            <strong>hygge</strong>
          </span>{" "} y los servicios
          que ofrece. Se trata de un marketplace o agregadora de espacios que
          facilita herramientas de reserva de espacios; los usuarios pueden
          subir espacios para que otros puedan reservarlos por horas, previo
          pago del precio facilitado en la Web.
          <br />
          <br />
          <strong>1.3 ¿Qué se pretende con este aviso legal?</strong>
          <br />
          <br />
          Con este Aviso se quiere informar al Usuario acerca de quién hay
          detrás de esta plataforma, así como que pueda conocer el tipo de
          información que recogemos y para qué la necesitamos. Junto con este
          texto, hemos dispuesto otros textos legales, como la Política de
          Privacidad, la Política de Cookies y las Términos y Condiciones.
          <br />
          <br />
          <strong>
            1.4 ¿Cómo contactar con el responsable de esta plataforma?
          </strong>
          <br />
          <br />
          Para contactar con nosotros el Usuario puede hacerlo en la dirección
          arriba indicada o, preferiblemente, a través de la siguiente dirección
          de correo electrónico: info@hygge.com.
          <br />
          <br />
          <strong>2. REGLAS DE FUNCIONAMIENTO</strong>
          <br />
          <br />
          <br />
          <br />
          <strong>2.1. ¿Cómo funciona esta Página Web?</strong>
          <br />
          <br />
          Puede visitar nuestra Web cuando quiera y de manera totalmente
          gratuita y libre, así como disfrutar de los servicios o informaciones
          que ofrecemos en la misma. En todo caso, para poder ser Usuario, es
          necesario que disponga de la mayoría de edad.
          <br />
          <br />
          <strong>2.2. Tipos de usuario en nuestra Plataforma</strong>
          <br />
          <br />
          a) <strong>Solicitante de información:</strong> es la persona que se
          pone en contacto a través cualquiera de los medios habilitados para
          requerir información sobre la Web. 
          <br />
          <br />b){" "}<strong>Usuario anfitrión:</strong> es aquel usuario que facilita sus
          espacios (salas de reuniones, terrazas, platós…) en la web de Spathios
          para su reserva. Puede ser cualquier tipo de persona o empresa que
          ponga a disposición sus espacios para que el Usuario huésped los
          utilice y, dentro de esta categoría o clasificación como usuario
          anfitrión, también existiría aquel que utiliza la plataforma para una
          gestión completa de sus espacios. Este usuario es identificado como
          Usuario Golden Host y sube espacios con alta frecuencia de reservas y
          a precios elevados; puede tratarse de cadenas de hoteles, restaurantes
          o inmobiliarias. Al igual que Administraciones Públicas y
          Universidades (identificado como Usuario Administración Pública) con
          espacios exclusivos propios de dichas instituciones.
          <br />
          <br /> c){" "}
          <strong>Usuario huésped:</strong> es la persona que reserva un espacio
          disponible en la Plataforma. Dentro de esta categoría, también pueden
          existir profesionales o empresas que reserven espacios de alto coste
          con una elevada frecuencia y que se identifica como Usuario Frequent
          Renter. d) <strong>Visitante:</strong> es la persona que simplemente
          navega por la Web.
          <br />
          <br />
          <strong>2.3. ¿Qué reglas de confidencialidad aplicamos?</strong>
          <br />
          <br />
          Cuando el Usuario navega por nuestra web podemos llegar a recoger sus
          datos de acuerdo con lo establecido en nuestra política de privacidad.
          Si bien si, como Usuario, por cualquier motivo, accede a información
          relativa a nuestros servicios o aspectos confidenciales de nuestro
          negocio, se sujeta a la más estricta confidencialidad, salvo que le
          indiquemos expresamente que es libre de utilizar esa información. En
          todo caso, cualquier Usuario de la Página Web deberá respetar lo
          establecido en nuestras condiciones de contratación.
          <br />
          <br />
          <strong>2.4. ¿Qué condiciones de uso se aplican?</strong>
          <br />
          <br />
          <br />
          <br />
          <strong>2.4.1. Aspectos generales</strong>
          <br />
          <br />
          Cualquier persona que acceda y navegue por la Web se convierte en
          Usuario de la misma, lo cual implica la aceptación de las condiciones
          de uso de esta página web detalladas en todas sus notas y políticas
          legales, relativas a la protección de datos, propiedad intelectual,
          medidas de seguridad y jurisdicción competente, entre otras. Como
          Usuario, al acceder a esta Web, asume los riesgos que pudieran
          producirse por su cuenta y riesgo. De este modo, debe ser responsable
          del uso de medios idóneos para evitar riesgos controlables que le
          atañan. También, como Usuario, debe leer atentamente el presente aviso
          legal en cada una de las ocasiones en que se proponga utilizar la
          Página Web, puesto que puede sufrir modificaciones y, por lo tanto, se
          sujetará y deberá obedecer a lo dispuesto. Además de estas condiciones
          de uso, deberá respetar en todo momento el resto de las normas de esta
          página web, pues regulan todos los derechos y deberes de los Usuarios
          para una mejor protección de los mismos, la protección de nuestra web
          y, por ende, también nuestro negocio.
          <br />
          <br />
          <strong>2.4.2. Derechos del Usuario</strong>
          <br />
          <br />
          <ul className={classes.ul}>
            <li>
              Como Usuario tiene derecho a navegar por la Página Web sujetándose
              siempre a las reglas establecidas en los avisos aplicables a la
              misma.
            </li>
            <li>
              Como Usuario tiene derecho a ser atendido respecto de sus dudas,
              comentarios o ejercicio de derechos, siguiéndose para todo ello
              los procedimientos establecidos en nuestra plataforma.
            </li>
            <li>
              Tiene derecho a que su información sea tratada con respeto y
              máxima privacidad, por lo que hemos dispuesto para ello una
              adecuada Política de Privacidad y protección de datos.
            </li>
          </ul>
          <br />
          <br />
          <strong>2.4.3. Prohibiciones del Usuario</strong>
          <br />
          <br />
          <ul className={classes.ul}>
            <li>
              No puede aprovechar su condición de Usuario para acceder a
              información que no le corresponde sobre la información o servicios
              ofrecidos en esta página web o sobre sus Usuarios y efectuar un
              uso no autorizado o en contra de la ley que pueda causar algún
              tipo de daño, ni al titular de esta web, ni a un tercero o
              Usuario.
            </li>
            <li>
              Está prohibido cualquier tipo de enlace hacia o desde páginas
              difamatorias, pornográficas, racistas o cualquier otra que ofrezca
              información falsa o perjudique a nuestra página web y a cualquiera
              de los profesionales o colaboradores que trabajan con o para ella.
            </li>
            <li>
              En ningún caso podrá suprimir, alterar, eludir o manipular
              cualquier dispositivo de protección o sistemas de seguridad que
              puedan estar instalados en la Web para cometer algún delito o
              fraude, atentar contra los derechos de propiedad intelectual,
              privacidad, confidencialidad de los usuarios de la Página Web o de
              su titular.
            </li>
          </ul>
          <br />
          <br />
          <strong>2.4.4. Derechos del titular</strong>
          <br />
          <br />
          El titular de esta web tiene derecho a tratar los datos del Usuario de
          acuerdo con lo establecido en estos avisos y en la correspondiente
          política de privacidad, utilizando dicha información para atender sus
          consultas, pudiendo llevar a cabo todas las medidas adecuadas según
          ley para poder prestar el servicio de forma efectiva.
          <br />
          <br />
          <strong>
            3. POLÍTICA DE CONTENIDOS, PROPIEDAD INTELECTUAL E INDUSTRIAL
          </strong>
          <br />
          <br />
          <br />
          <br />
          <strong>3.1. Tipo de contenidos de nuestra Plataforma</strong>
          <br />
          <br />
          <br />
          <br />
          <strong>3.1.1. Política de propiedad intelectual</strong>
          <br />
          <br />
          <ul className={classes.ul}>
            <li>
              Nuestra política de propiedad intelectual es aplicable a toda la
              Web, así como a los contenidos y materiales difundidos mediante
              esta.
            </li>
            <li>
              El Usuario reconoce expresamente, y a todos los efectos, que la
              información, signos, imágenes, diseños, logotipos, animaciones,
              vídeos, textos, así como los demás elementos y contenidos,
              incluidos sus servicios y aplicaciones informáticas, de la
              Plataforma, están sujetos a derechos de propiedad industrial e
              intelectual de <span style={{ color: "#005795" }}>
            <strong>hygge</strong>
          </span>{" "} o de terceros titulares de los mismos que
              han autorizado debidamente su inclusión en la Página Web, por lo
              que no se les concede ningún tipo de derecho sobre ellos, salvo
              los que expresamente se reconozcan.
            </li>
            <li>
              Los Usuarios que accedan a la Web pueden visualizar la información
              contenida y efectuar descargas o reproducciones privadas en su
              sistema informático, siempre que los elementos reproducidos no
              sean cedidos posteriormente a terceros o se instalen en un
              servidor conectado a Internet o a una red local.
            </li>
            <li>
              En consonancia con lo dispuesto en el apartado anterior, el
              Usuario no estará facultado para, a título meramente enunciativo:
              distribuir, modificar, transformar, ceder, poner a disposición del
              público o llevar a cabo cualquier otra actividad que no haya sido
              expresamente autorizada, sobre los elementos y contenidos
              indicados anteriormente, incluidos los códigos informáticos de
              cualquiera de los elementos de esta Web.
            </li>
            <li>
              El Usuario que proceda al envío de cualquier tipo de contenido a
              nuestra web asegura que ostenta los derechos necesarios para
              hacerlo, quedando exento Spathios de cualquier responsabilidad
              sobre el contenido y legalidad de la información ofrecida.
            </li>
            <li>
              El Usuario reconoce a <span style={{ color: "#005795" }}>
            <strong>hygge</strong>
          </span>{" "} el derecho a modificar los
              contenidos introducidos a fin de que se adecúen y sean compatibles
              con las características técnicas y estéticas de la plataforma.
            </li>
          </ul>
          <br />
          <br />
          <strong>
            3.1.2. Límites del Usuario respecto al acceso y uso de nuestros
            contenidos
          </strong>
          <br />
          <br />
          El acceso a los contenidos de propiedad intelectual por su parte como
          Usuario no le transfiere ningún derecho sobre los mismos. En este
          sentido, el uso que le dé a esta información y contenidos solo puede
          ser privativo (utilizado de un modo privado); cualquier uso o
          reproducción realizado por los Usuarios u otros que se puedan incluir
          en un futuro, deberá realizarse conforme a las previsiones y políticas
          legales aquí establecidas, respetando en todo caso las limitaciones
          legales aplicables.
          <br />
          <br />
          En concreto, está prohibida:
          <br />
          <br />
          <ul className={classes.ul}>
            <li>
              La reproducción, transformación, distribución, comunicación
              pública, puesta a disposición del público o cualquier otra
              explotación de los contenidos de esta página web sin el
              consentimiento por escrito del respectivo titular.
            </li>
            <li>
              Tampoco se podrán realizar enlaces a esta web sin el
              consentimiento de su titular y, en su caso, solo se permitirán
              enlaces a la página principal.
            </li>
            <li>
              Si quiere solicitarnos algún tipo de permiso para utilizar o
              publicar alguno de nuestros contenidos de la Página Web, puede
              dirigirse a nosotros por alguno de los medios indicados en el
              punto 1.4 de este aviso.
            </li>
          </ul>
          <br />
          <br />
          <strong>3.1.3. Autorizaciones o permisos</strong><br /><br />
          Como Usuario podrá visualizar los
          elementos de la Plataforma e incluso imprimirlos, copiarlos y
          almacenarlos en el disco duro de su dispositivo o en cualquier otro
          soporte físico, siempre y cuando sea, única y exclusivamente, para un
          uso personal y privado, quedando, por tanto, prohibida su utilización
          con fines comerciales, su distribución, así como su modificación,
          alteración o descompilación.
          <br />
          <br />
           No obstante, como excepción a lo indicado
          en el punto anterior, le permitimos que como Usuario comparta aquello
          relativo a la web a través de redes sociales, con las acciones “tuit,
          retuit, compartir, bloguear” o similares, siempre y cuando se respete
          nuestra titularidad o la mención a las personas correspondientes.
          <br /><br /><strong>3.1.4. Enlaces entre páginas web</strong><br /><br />
          (1) Aquellas personas o empresas que
          se propongan establecer un hiperenlace entre su página web y esta (en
          adelante, el hiperenlace), deberán cumplir las condiciones siguientes:
          <br />
          <br />
          <ul className={classes.ul}>
            <li>
              El hiperenlace únicamente permitirá el acceso al home de la Página
              Web, pero no podrá reproducirla de ninguna forma.
            </li>
            <li>No se creará un frame sobre las páginas de la Plataforma.</li>
            <li>
              No se declarará ni se dará a entender que Spathios ha autorizado
              el hiperenlace o que ha supervisado o asumido de cualquier forma
              los servicios ofrecidos o puestos a disposición desde la página
              web en la que se establece el hiperenlace.
            </li>
            <li>
              Excepción hecha de aquellos signos que formen parte del mismo
              hiperenlace, la página web en la que se establezca el hiperenlace
              no contendrá ninguna marca, nombre comercial, rótulo de
              establecimiento, denominación, logotipo, eslogan u otros signos
              distintivos pertenecientes a Spathios.
            </li>
            <li>
              La página web en la que se establezca el hiperenlace no contendrá
              informaciones o contenidos ilícitos, contrarios a la moral y a las
              buenas costumbres generalmente aceptadas y al orden público, así
              como contenidos contrarios a cualesquiera derechos de terceros.
            </li>
            <li>
              El establecimiento del hiperenlace no implica, en ningún caso, la
              existencia de relaciones entre Spathios y el propietario de la
              página web en la que se establezca, ni la aceptación y aprobación
              por parte de Spathios de sus contenidos o servicios.
            </li>
          </ul>
          <br />
          <br />
          (2) <span style={{ color: "#005795" }}>
            <strong>hygge</strong>
          </span>{" "} pone a disposición de los Usuarios enlaces o links con el
          fin de facilitar el acceso a la información, servicios y demás
          contenidos disponibles en Internet. Los enlaces o links habilitados en
          la Página Web pueden conducir al Usuario a otros sitios y páginas web
          gestionadas por terceros, sobre los que Spathios no ejerce ningún tipo
          de control.
          <br />
          <br />
          (3) <span style={{ color: "#005795" }}>
            <strong>hygge</strong>
          </span>{" "} no asume ningún deber de vigilar ni de verificar las
          informaciones o contenidos de los otros sitios o páginas web a los que
          quepa acceder mediante los hiperenlaces existentes en la Web. Asume,
          exclusivamente, el deber de suprimir de esta página, con la mayor
          brevedad posible, las informaciones, contenidos o servicios que no se
          correspondan con la realidad, atenten contra cualquier normativa
          aplicable o puedan inducir a error o causar daño al Usuario.
          <br />
          <br />
          <strong>
            3.2. Respecto del software correspondiente a esta plataforma y de su
            diseño
          </strong>
          <br />
          <br />
          <ul className={classes.ul}>
            <li>
              El titular de esta Plataforma dispone de los permisos y licencias
              para utilizarla, así como de los derechos relativos a su diseño.
              Cualquier uso del código de programación, software o diseño por
              parte de los Usuarios no está permitido, siendo responsables los
              mismos de cualquier uso fraudulento o en perjuicio de derechos del
              titular de la Plataforma, o de terceros.
            </li>
            <li>
              En ningún caso podrá extraer, manipular, copiar, compilar o
              descompilar ningún elemento que componga la Plataforma, con fines
              ajenos o que escapen del objeto de lo ofrecido en la misma,
              pudiendo emprender acciones legales si se detecta alguna acción en
              contra y por dicho motivo.
            </li>
          </ul>
          <br />
          <br />
          <strong>
            3.3. Respecto de nuestra marca e identidad corporativa
          </strong>
          <br />
          <br />
          <ul className={classes.ul}>
            <li>
              Como Usuario no podrá utilizar nuestra marca, dominio, eslogan o
              cualquier elemento que configure nuestra identidad corporativa sin
              solicitarnos permiso expreso para ello.
            </li>
          </ul>
          <br />
          <br />
          <strong>3.4. Reglas complementarias</strong>
          <br />
          <br />
          <ul className={classes.ul}>
            <li>
              En lo no dispuesto en nuestros avisos, se estará al cumplimiento
              de lo dispuesto en la legislación y normativa aplicable de
              propiedad intelectual e industrial.
            </li>
          </ul>
          <br />
          <br />
          <strong>4. RÉGIMEN DE RESPONSABILIDADES</strong>
          <br />
          <br />
          <br />
          <br />
          <strong>4.1. Responsabilidad de acceso a la Plataforma</strong>
          <br />
          <br />
          El acceso a nuestra plataforma será responsabilidad exclusiva del
          Usuario, tanto en la forma de acceso como en la información que
          facilita, así como en la seguridad con que navega a través de ella.
          <br />
          <br />
          Por su parte, el titular de la Web se compromete a realizar el mejor y
          más grande esfuerzo, en la medida de lo razonablemente posible, para
          evitar errores en los contenidos publicados y ofrecer un servicio
          constante y permanente a través de ella. No podemos responsabilizarnos
          por las suspensiones temporales, averías o fallos técnicos que afecten
          a la plataforma, provocados por causas ajenas a nuestro negocio, por
          virus o inseguridad informática ocasionada por terceros, ni por las
          actuaciones ilegales e irrespetuosas de los Usuarios. 
          <br />
          <br />
          <span style={{ color: "#005795" }}>
            <strong>hygge</strong>
          </span>{" "} no
          garantiza la disponibilidad, continuidad o infalibilidad del
          funcionamiento de la plataforma y, en consecuencia, excluye, en la
          máxima medida permitida por la legislación vigente, cualquier
          responsabilidad por los daños y perjuicios de toda naturaleza que
          puedan deberse a la falta de disponibilidad o de continuidad del
          funcionamiento de la Página Web y de los servicios habilitados en la
          misma, así como a los errores en el acceso.
          <br />
          <br />
           También, <span style={{ color: "#005795" }}>
            <strong>hygge</strong>
          </span>{" "} declina
          toda responsabilidad por los daños informáticos o de otro tipo que
          pudiera ocasionar al Usuario visitante en el acceso a los contenidos
          de la Plataforma. Por ello, no garantiza la ausencia de virus u otros
          elementos lesivos que pudieran causar daños o alteraciones en el
          sistema informático, en los documentos electrónicos, o en los ficheros
          del Usuario o de terceros.
          <br />
          <br />
          <strong>4.2. Respecto de los contenidos publicados </strong>
          <br />
          <br />
          Desde <span style={{ color: "#005795" }}>
            <strong>hygge</strong>
          </span>{" "} tampoco nos responsabilizamos por el contenido y/o
          actualización de los enlaces publicados en nuestra plataforma, o de la
          información que indexe la misma y que esté relacionada con otros
          sitios webs, aplicaciones o con otras empresas que resulten vinculadas
          a los criterios de búsqueda de contenido.
          <br />
          <br />
           Revisaremos y actualizaremos
          la información publicada en nuestra plataforma, pero no podemos
          garantizar que toda ella sea totalmente correcta puesto que pueden
          producirse errores tipográficos, de información inexacta o incompleta
          por cualquier razón plenamente justificable.
          <br />
          <br />
           Sin perjuicio de las
          limitaciones establecidas en la legislación vigente, Spathios no se
          responsabiliza por los daños y perjuicios de toda naturaleza que
          puedan deberse a la falta de exactitud, exhaustividad, actualidad, así
          como a errores u omisiones de los que pudieran adolecer las
          informaciones contenidas en la plataforma u otros contenidos a los que
          se pueda acceder a través de la misma.
          <br />
          <br />
          <strong>
            4.3. Responsabilidad en relación con los fallos del servicio
          </strong>
          <br />
          <br />
          En general, ni la plataforma ni su titular responden por los errores
          técnicos en la Plataforma y/o de no suministro del servicio de
          Internet: (i) por causa de acciones o errores de terceros y/o (ii) por
          causas propias cuando se resuelva el incidente y/o actúe de manera
          diligente.
          <br />
          <br />
          <strong>4.4. Otras responsabilidades y deberes</strong>
          <br />
          <br />
          <ul className={classes.ul}>
            <li>
              Si <span style={{ color: "#005795" }}>
            <strong>hygge</strong>
          </span>{" "} fuera declarada no responsable de cualquier daño o
              perjuicio con causa a los anteriores extremos en un procedimiento
              judicial o extrajudicial, por un Juzgado, Tribunal o Ente Público
              administrativo competente, y lo fuera el Usuario, podrá repetir
              contra este todas las cantidades que haya tenido que abonar y
              soportar, incluido el daño emergente y el lucro cesante, y
              cualquier coste o gravamen que hubiera tenido que afrontar,
              incluidos impuestos, tasas, abogados, procuradores, peritos,
              arbitrajes, viajes, estancias, y cualquier otro.
            </li>
            <li>
            <span style={{ color: "#005795" }}>
            <strong>hygge</strong>
          </span>{" "}se reserva el derecho de comunicar la información
              confidencial que los Usuarios le hayan comunicado cuando venga
              impuesto por ley, reglamento, normativa, ordenanza y/o cualquier
              otro mandato legal, judicial o solicitud gubernamental.
            </li>
          </ul>
          <br />
          <br />
          <strong>5. PROTECCIÓN Y FUNCIONAMIENTO DE LA PLATAFORMA</strong>
          <br />
          <br />
          <span style={{ color: "#005795" }}>
            <strong>hygge</strong>
          </span>{" "} mantendrá operativa la Página Web durante todo el año, las 24
          horas del día, siempre que el estado de la técnica lo permita.<br/><br/>
          No obstante, se reserva el derecho de modificar o interrumpir, en todo o
          en parte, el acceso al sistema de forma temporal cuando el servicio de
          mantenimiento, actualización o reparación del sistema o el servidor de
          Internet lo requiera, sin necesidad de haberlo notificado al Usuario.<br/><br/>
          Si el Usuario detectara alguna anomalía, interferencias de terceros,
          errores del sistema o mal funcionamiento de la Plataforma, deberá
          notificarlo, dirigiéndose para ello, al correo electrónico de
          contacto: <strong>info@hygge.com</strong> o al número de teléfono <strong>633 000 000</strong> para
          que Spathios proceda a revisar lo que sucedió y, en su caso, a buscar
          una posible solución.
          <br />
          <br />
          <strong>6. DERECHO DE MODIFICACIÓN DE ESTE AVISO</strong>
          <br />
          <br />
          Nos reservamos el derecho a modificar este aviso para adaptarlo a las
          novedades legislativas o jurisprudenciales que vayan surgiendo o
          publicándose, así como efectuar las modificaciones oportunas de
          acuerdo con las prácticas de la industria o comerciales. 
          <br/><br/>Cuando se
          produzca un cambio sustancial o de relevancia en las mismas,
          avisaremos mediante la presente Plataforma, y con una antelación
          prudencial, de los cambios que se vayan a producir en nuestras
          políticas, indicando cuándo está previsto que comiencen a tener plenos
          efectos.
          <br />
          <br />
          <strong>7. NORMATIVA APLICABLE A ESTA PLATAFORMA</strong>
          <br />
          <br />
          Todos nuestros textos y políticas legales asociados a esta plataforma
          se rigen, en todos y cada uno de sus extremos, por la legislación
          española, entre ellas: la Ley 34/2002, de Servicios a la Sociedad de
          la Información y de Comercio Electrónico, la Ley Orgánica 3/2018, de 5
          de diciembre, de Protección de Datos Personales y garantía de los
          derechos digitales, el Reglamento Europeo de Protección de Datos
          679/2016 y cuantas disposiciones legales resulten de aplicación a la
          Página Web y/o productos o servicios ofrecidos.
          <br />
          <br />
          <strong>8. EXCLUSIONES DE LA POLÍTICA LEGAL DE LA PLATAFORMA</strong>
          <br />
          <br />
          La presente política legal solamente afecta a la información publicada
          y al tratamiento de datos realizado en base a nuestra plataforma. En
          ningún caso, las condiciones aquí establecidas tienen que estar
          necesariamente relacionadas con las políticas de Spathios por lo que
          se refiere a la prestación de servicios en sí, así como a la forma de
          prestación de estos por parte de su titular.
          <br />
          <br />
          <strong>9. JURISDICCIÓN COMPETENTE</strong>
          <br />
          <br />
          En el supuesto de que surja cualquier conflicto o discrepancia en la
          interpretación de las presentes condiciones o aviso, los Juzgados y
          Tribunales que, en su caso, conocerán del asunto, serán los que
          disponga la normativa legal aplicable en materia de jurisdicción
          competente. 
          <br/><br/>En todo caso, si su situación es como consumidor final,
          serán competentes los tribunales correspondientes a su domicilio. 
          <br/><br/>En
          el caso de personas jurídicas, las partes se sujetarán a los
          tribunales de Galicia.
          <br />
          <br />
          <strong>
            10. ¿A QUÉ OTRAS POLÍTICAS LEGALES SE SUJETA ESTE AVISO Y EL
            USUARIO?
          </strong>
          <br />
          <br />
          El presente aviso legal se complementa con el resto de las políticas
          legales establecidas en nuestra Plataforma, ya comentadas a lo largo
          de este aviso, como la Política de Privacidad, la Política de Cookies
          los Términos y Condiciones y las Condiciones Particulares además de
          cualquier otra que sea necesario añadir o complementar, siguiendo lo
          dispuesto en la legislación vigente en cada momento, todo para velar
          por el interés de nuestros Usuarios, dándoles la mayor imagen de
          garantía y transparencia.
        </Typography>
      </Paper>
    </div>
  );
};
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: "#FEFCF3",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
  },
  paper: {
    maxWidth: "90vw",
    backgroundColor: "#FEFCF3",
    padding: theme.spacing(5),
  },
  title: {
    textAlign: "center",
    padding: theme.spacing(4, 0, 2, 0),
    color: "#005795",
    fontWeight: "bold",
  },
  ul: {
    marginLeft: theme.spacing(5),
  },
  link: {
    color: "#005795",
    textDecoration: "none",
  },
}));

export default Avisos;
